module.exports = __webpack_public_path__ + "img/03_Cigarette.c87be75c.png";